module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAAAICAYAAABkmUMJAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACZSURBVHgB7dnBCcJAFEXRlzGCyynBEpJObMEOdOdylu4swRZiB3agJaSELAMG4htIFZ97YOAzBVz+MI3sUG7HVvunx84nCwDiGBb9rnO5j80Wu48IHYC4JkevT47dQ8QOQGy5vmKTh5MAIL6uBm8SAMSXHbz1KwCI75UWtWex5QGIzZ8Wu0uaSxk99L4YBACxeJlb37VxtXV/4qQirgTAB9AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/case_under.png
// module id = 50
// module chunks = 0